{
    "order": {
        "show": {
            "greeting": {
                "introduction": "Bedankt dat u ervoor gekozen heeft om Scouting Raalte te steunen met uw bestelling!"
            }
        },
        "stateAlert": {
            "refunded": "Je bestelling is terugbetaald. We komen niet meer langs. Is dit een foutje? Neem dan contact met ons op via (0572) 358375.",
            "deleted": "Je bestelling is geannuleerd. Is dit een foutje? Neem dan contact met ons op via (0572) 358375."
        }
    }
}
